import { useEffect } from 'react';
import { useNavigate } from 'src/lib/routing';

import { useAppContext } from 'components/common/Askable/Providers/appProvider';

// Legacy self-serve checkout route, kept so old links still explain why credit purchasing
// went away. The modal lives above the Outlet, so it survives the redirect to the index route.
function CreditsOrderAction() {
  const context = useAppContext();
  const navigate = useNavigate();

  useEffect(() => {
    context.onOpenBuyCreditsModal();
    navigate({ pathname: '/' }, { replace: true });
  }, []);

  return null;
}

export default CreditsOrderAction;
